import React, { useState } from 'react';
import { Dialog, Button, Box, Typography, Stack } from '@mui/material';

interface CompleteConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

const CompleteOrder: React.FC<CompleteConfirmationProps> = ({ isOpen, onClose, onConfirm }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleConfirmClick = async () => {
    setIsProcessing(true);
    try {
      await onConfirm(); 
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        zIndex: 1400,
        '& .MuiDialog-paper': {
          borderRadius: 0,
          maxWidth: 450,
          width: '100%',
          m: 2,
          backgroundColor: 'white'
        },
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 3,
          textAlign: 'center',
          backgroundColor: 'white'
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'rgba(254, 122, 122, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2
          }}
        >
          <Typography variant="h1" color="error" sx={{ fontWeight: 'bold' }}>
            !
          </Typography>
        </Box>

        <Typography
          variant="h3"
          sx={{
            mb: 3,
            color: '#303030',
            fontSize: '1.2rem',
            fontWeight: 800
          }}
        >
          Are you sure you want to <br />
          submit this order?
        </Typography>

        <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            disabled={isProcessing}
            sx={{
              textTransform: 'none',
              color: '#303030',
              borderColor: '#d0d0d0',
              borderRadius: 0,
              fontSize: '0.9rem',
              '&:hover': {
                borderColor: '#c0c0c0',
                backgroundColor: 'rgba(0, 0, 0, 0.03)'
              }
            }}
          >
            Back
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmClick}
            disabled={isProcessing}
            sx={{
              textTransform: 'none',
              backgroundColor: '#008E9C',
              borderRadius: 0,
              fontSize: '0.9rem',
              '&:hover': {
                backgroundColor: '#01707a'
              }
            }}
          >
            Yes
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default CompleteOrder;
